import React from 'react';

const FormDivider = ({
    display = true
}) => {
    return <div
        className="form-divider"
        style={{
            display: display? '' : 'none'
        }}
    />;
};

export default FormDivider;